import React from 'react';
import { Link } from 'react-router-dom';
import "./style.scss";

const sizes = {
  medium: "3.5rem",
  large: "4.5rem",
}

function Logo({idPrefix, size="medium", className}) {
  if (!idPrefix) throw new Error("idPrefix is required");
  return (
    <Link to="/" className={["Logo", className].join(" ")}>
      <svg className="Logo__icon" height={sizes[size]} style={{minHeight: sizes[size]}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 676.47 134.71">
        <g>
          <radialGradient id={idPrefix + "-gradient-1"} cx="569.7953" cy="78.4636" r="82.9463" gradientUnits="userSpaceOnUse">
            <stop offset="0" style={{stopColor:"#B92D19"}}/>
            <stop offset="0.11" style={{stopColor:"#8A1002"}}/>
            <stop offset="0.28" style={{stopColor:"#B90E0C"}}/>
            <stop offset="0.53" style={{stopColor:"#E30613"}}/>
            <stop offset="0.77" style={{stopColor:"#E63323"}}/>
            <stop offset="0.86" style={{stopColor:"#EF7858"}}/>
            <stop offset="0.92" style={{stopColor:"#FAC9B5"}}/>
            <stop offset="1" style={{stopColor:"#F6AF95"}}/>
          </radialGradient>
          <path style={{fill:`url(#${idPrefix}-gradient-1)`}} d="M555.44,107.22c-2.95-1.01-18.34-9.68-18.17-27.6c0-10.94,6.23-20.03,7.99-22.13
            c1.77-2.1,10.43-11.44,18.76-14.05s13.21-2.94,18.93-2.94c5.72,0,24.82,0,24.82,0s-4.94,25.92-5.22,27.01
            c-0.5,2.02-0.5,3.95-5.3,3.95c-4.88,0-34.67,0-34.67,0c-3.73,0-4.8,5.67-1.6,6.9C560.32,81.73,555.44,107.22,555.44,107.22z"
          />
        
          <linearGradient id={idPrefix + "-gradient-2"} gradientUnits="userSpaceOnUse" x1="554.232" y1="93.9314" x2="591.5925" y2="101.6728">
            <stop offset="0" style={{stopColor:"#F6AF95"}}/>
            <stop offset="0.07" style={{stopColor:"#FAC9B5"}}/>
            <stop offset="0.14" style={{stopColor:"#EF7858"}}/>
            <stop offset="0.23" style={{stopColor:"#E63323"}}/>
            <stop offset="0.5" style={{stopColor:"#E30613"}}/>
            <stop offset="0.71" style={{stopColor:"#B90E0C"}}/>
            <stop offset="0.85" style={{stopColor:"#8A1002"}}/>
            <stop offset="1" style={{stopColor:"#B92D19"}}/>
          </linearGradient>
          <path style={{fill:`url(#${idPrefix}-gradient-2)`}} d="M560.74,107.56
            c-3.79,19.94,25.5,22.21,29.79,0c2.55-13.21,5.81-30.74,5.81-30.74h-29.7L560.74,107.56z"
          />
        
          <radialGradient id={idPrefix + "-gradient-3"} cx="542.1523" cy="24.5515" r="119.8859" gradientUnits="userSpaceOnUse">
            <stop offset="0" style={{stopColor:"#F6AF95"}}/>
            <stop offset="0.07" style={{stopColor:"#FAC9B5"}}/>
            <stop offset="0.14" style={{stopColor:"#EF7858"}}/>
            <stop offset="0.23" style={{stopColor:"#E63323"}}/>
            <stop offset="0.5" style={{stopColor:"#E30613"}}/>
            <stop offset="0.71" style={{stopColor:"#B90E0C"}}/>
            <stop offset="0.85" style={{stopColor:"#8A1002"}}/>
            <stop offset="1" style={{stopColor:"#B92D19"}}/>
          </radialGradient>
          <path style={{fill:`url(#${idPrefix}-gradient-3)`}} d="M596.08,107.81l5.72-30.12
            c0,0,4.07,0.45,5.41-5.72c1.15-5.29,5.35-27.62,6.37-32.73c1.51-7.66-8.75-6.82-9.68-3.28c-5.3,0-24.91,0-24.91,0
            s-7.07,0-9.59,1.43c2.27-5.55,9.93-12.12,15.4-15.4c5.47-3.28,12.45-6.31,21.79-6.39c9.34-0.08,20.36,2.19,27.43,8.16
            s9.24,12.4,10.01,18.51c0.76,5.97,2.02,18.18-7.99,36.52C625.62,97.88,607.19,105.29,596.08,107.81z"
          />
        
          <radialGradient id={idPrefix + "-gradient-4"} cx="611.4815" cy="42.0527" r="59.0259" gradientUnits="userSpaceOnUse">
            <stop offset="0" style={{stopColor:"#F6AF95"}}/>
            <stop offset="0.07" style={{stopColor:"#FAC9B5"}}/>
            <stop offset="0.14" style={{stopColor:"#EF7858"}}/>
            <stop offset="0.23" style={{stopColor:"#E63323"}}/>
            <stop offset="0.5" style={{stopColor:"#E30613"}}/>
            <stop offset="0.71" style={{stopColor:"#B90E0C"}}/>
            <stop offset="0.85" style={{stopColor:"#8A1002"}}/>
            <stop offset="1" style={{stopColor:"#B92D19"}}/>
          </radialGradient>
          <path style={{fill:`url(#${idPrefix}-gradient-4)`}} d="M643.91,72.34
            c1.23-3.25,7.18-16.2,4.15-30.45c9.76-0.11,15.17,9.02,13.24,16.53C659.28,66.29,653.55,71,643.91,72.34z"
          />
        </g>
        <g>
          <path style={{fill: "#A2A7AD"}} d="M54.29,82.06c-9.64-1.63-16.74-3.26-22.24-8.72c-5.73-5.47-7.57-13.4-5.94-22.72
            c1.63-9.31,5.8-17.26,12.68-23.57c6.04-5.49,15.27-10.71,27.73-10.73c17.78-0.03,31.52,9.8,29.88,19.11
            c-1.06,6.03-6.93,13.16-15.24,13.17c-6.23,0.01-10.29-7.1-16.53-7.09c-4.85,0.01-8.88,1.93-9.5,5.49c-0.67,3.84,1.34,6.84,7.33,8.2
            c6.64,1.63,14.45,0.52,24.03,10.36c5.22,5.74,6.74,12.86,5.16,21.9c-2.88,16.43-16.08,35.08-43.79,35.12
            c-18.93,0.03-33.23-9.25-31.16-21.03c1.15-6.57,8.67-11.24,14.44-11.25c7.16-0.01,9.74,7.65,21.05,7.63
            c6.46-0.01,11.01-3.58,11.64-7.14C64.6,86.42,60.56,83.15,54.29,82.06z"/>
          <path style={{fill: "#A2A7AD"}} d="M121.57,119.73c-16.85,0.03-23.91-0.5-20.89-17.76l11.97-68.2c1.54-8.76,7.77-15.35,15.16-15.36l38.1-0.07
            c6.46-0.01,11.19,4.63,10.13,10.66c-2.16,12.32-11.91,12.62-25.99,12.64c-7.62,0.01-11.98,2.49-12.6,6.05
            c-0.87,4.93,2.77,6.57,10.39,6.55c9.47-0.02,21.29-0.31,19.13,12.01c-1.97,11.23-12.82,11.25-20.9,11.26
            c-12.93,0.02-16.56,3.59-17.57,9.34c-1.59,9.04,4.04,9.85,21.36,9.82c0.46,0,19.04-1.95,16.78,10.92
            c-2.31,13.15-19.66,12.08-24.05,12.09L121.57,119.73z"/>
          <path style={{fill: "#A2A7AD"}} d="M206.21,101.92c-2.36,13.42-8.41,20.28-17.87,20.29c-12.47,0.02-12.44-10.66-10.03-24.35l10.91-60.8
            c2.12-12.05,7.76-20.55,16.3-20.56c11.54-0.02,14.69,5.72,11.13,25.99L206.21,101.92z"/>
          <path style={{fill: "#A2A7AD"}} d="M298.65,30.29c-1.59,9.04-7.43,13.43-17.36,13.45l-14.78,0.03c-5.08,0.01-8.98,2.48-9.65,6.31
            c-0.82,4.66,2.77,6.57,7.85,6.56l10.16-0.02c11.31-0.02,15.2,5.45,13.9,12.84c-2.6,14.79-15.05,13.44-30.06,13.47
            c-7.39,0.01-10.85,6.59-11.56,9.33c-0.95,4.11-3.15,15.34-4.33,18.08c-1.69,4.38-6.36,11.24-13.98,11.25
            c-8.73-0.26-12.43-5.45-10.03-19.15l11.83-67.38c1.83-10.41,8.06-16.99,16.83-17.01l40.17-0.07
            C295.5,17.97,299.9,23.17,298.65,30.29z"/>
          <path style={{fill: "#A2A7AD"}} d="M317.2,119.38c-16.85,0.03-23.92-0.5-20.89-17.76l11.97-68.2c1.54-8.76,7.77-15.35,15.16-15.36l38.09-0.07
            c6.47-0.01,11.19,4.64,10.13,10.66c-2.16,12.33-11.91,12.62-25.99,12.64c-7.62,0.01-11.98,2.49-12.6,6.05
            c-0.87,4.93,2.77,6.57,10.39,6.55c9.47-0.02,21.29-0.31,19.12,12.01c-1.97,11.23-12.82,11.25-20.9,11.26
            c-12.93,0.02-16.56,3.59-17.57,9.34c-1.59,9.04,4.04,9.85,21.36,9.82c0.46,0,19.04-1.95,16.78,10.92
            c-2.31,13.15-19.66,12.08-24.05,12.09L317.2,119.38z"/>
          <path style={{fill: "#A2A7AD"}} d="M431.87,119.18c-6.7,0.01-10.74-3.27-12.86-9.56l-4.7-13.96c-1.63-5.2-4.15-7.93-6.22-7.93
            c-5.08,0.01-7.83,3.85-9.51,13.43c-2.12,12.05-7.51,17.81-14.9,17.82c-7.85,0.01-11.74-5.46-10.73-11.21l12.64-70.67
            c2.65-15.06,8.63-18.91,19.02-18.93l24.47-0.04c26.09-0.05,30.68,17.2,28.18,31.44c-0.91,5.2-2.15,9.59-4.16,13.15
            c-6.45,11.79-13.4,12.27-13.95,18.52c-0.71,8.03,5.82,21.2,4.62,28.04C442.51,116.42,438.56,119.17,431.87,119.18z M416.29,61.98
            c8.77-0.01,13.79-4.95,14.76-10.43c1.11-6.3-2.1-10.4-9.44-10.66c-7.57-0.26-12.4,3.58-13.6,10.43
            C406.76,58.44,410.75,61.99,416.29,61.98z"/>
          <path style={{fill: "#A2A7AD"}} d="M482.1,55.16c1.44-8.22-0.34-11.23-8.63-13.95c-5.67-1.91-7.99-5.74-7.03-11.21
            c1.35-7.67,6.87-11.51,16.56-11.53l34.86-0.06c10.62-0.02,14.33,3.81,12.94,11.75c-0.91,5.2-4.45,9.59-10.7,10.97
            c-9.34,1.93-12.32,5.77-13.77,13.99c-2.21,12.6-6.15,35.06-8.51,48.48c-2.36,13.42-8.44,17.81-14.67,17.82
            c-8.77,0.02-11.69-5.73-9.53-18.06L482.1,55.16z"/>
        </g>
      </svg>
    </Link>
  );
}

export default Logo;
